import {createApi} from "@reduxjs/toolkit/query/react"
import baseQuery from "../../utils/apiIIKOConfig"
import {IBasicResponse} from "../../types/api"
import {
    IReviewCategoryTagCreateParams,
    IReviewCategoryTagCreateResponse,
    IReviewCategoryTagDeleteParams,
    IReviewCategoryTagGet,
    IReviewCategoryTagUpdateParams
} from "./ReviewCategoryTagApiTypes"

export const reviewCategoryTagApi = createApi({
    reducerPath: "reviewCategoryTagApi",
    baseQuery,
    tagTypes: ["review-category-tags"],
    endpoints: build => ({
        createReviewCategoryTags: build.mutation<IBasicResponse<IReviewCategoryTagCreateResponse>, IReviewCategoryTagCreateParams>({
            query: ({name}) => ({
                method: "POST",
                url: `v1/review-category-tags`,
                body: {name}
            }),
            invalidatesTags: ["review-category-tags"]
        }),
        getReviewCategoryTags: build.query<IBasicResponse<IReviewCategoryTagGet[]>, void>({
            query: () => ({
                method: "GET",
                url: `v1/review-category-tags/list`,
            }),
            providesTags: ["review-category-tags"]
        }),
        updateReviewCategoryTags: build.mutation<IBasicResponse<void>, IReviewCategoryTagUpdateParams>({
            query: ({id, name}) => ({
                method: "PUT",
                url: `v1/review-category-tags/${id}`,
                body: {name}
            }),
            invalidatesTags: ["review-category-tags"]
        }),
        removeReviewCategoryTags: build.mutation<IBasicResponse<void>, IReviewCategoryTagDeleteParams>({
            query: ({id}) => ({
                method: "DELETE",
                url: `v1/review-category-tags/${id}`,
            }),
            invalidatesTags: ["review-category-tags"]
        }),
    })
})

export const {
    useCreateReviewCategoryTagsMutation,
    useGetReviewCategoryTagsQuery,
    useUpdateReviewCategoryTagsMutation,
    useRemoveReviewCategoryTagsMutation
} = reviewCategoryTagApi
